import { type FC } from 'react';
import classnames from 'classnames';
import dibsCss from 'dibs-css';

import { CarouselArrowButton } from 'dibs-scroll-carousel/exports/CarouselArrowButton.ts';

import styles from './ThumbScrollArrow.scss';

export const ThumbScrollArrow: FC<{
    direction: 'up' | 'down';
    onClick: () => void;
}> = ({ direction, onClick }) => (
    <CarouselArrowButton
        direction={direction}
        size="small"
        onClick={onClick}
        dataTn={`thumb-scroll-${direction}`}
        ariaLabel={`Scroll thumbnails ${direction}`}
        className={classnames(
            dibsCss.left50,
            styles.thumbArrow,
            direction === 'up' ? styles.thumbArrowUp : styles.thumbArrowDown
        )}
    />
);
